// https://vuex.vuejs.org/en/getters.html

export default {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  user: state => state.user,
  locale: state => state.locale,
  account: state => JSON.parse(state.account),
  calcTypes: state => state.calcTypes,
  priceRuleTypes: state => state.priceRuleTypes,
  genders: state => state.genders,
  countries: state => state.countries,
  languages: state => state.languages,
  newReservation: state => state.newReservation,
  navigation: state => state.navigation,
  serviceTypes: state => state.serviceTypes,
  prebuildTrip: state => state.prebuildTrip,
  prebuildBlock: state => state.prebuildBlock,
  serviceCategories: state => state.serviceCategories,
  reservation: state => state.reservation
}



// WEBPACK FOOTER //
// ./src/store/getters.js